module.exports = __webpack_public_path__ + "img/divider_rough_edge_bottom.59409f6a.svg";